import clsx from 'clsx'
import type { DocTable as DocTableModel, DocTableCell } from '../../docs'
import { DocInline } from './DocInline'
import styles from './Docs.module.scss'

interface DocTableProps {
  table: DocTableModel
  id?: string
  'data-testid'?: string
}

function Cell({ cell, mono }: { cell: DocTableCell; mono: boolean }) {
  if (typeof cell !== 'string') {
    return <code className={styles.cellCode}>{cell.code}</code>
  }
  if (mono) {
    return <code className={styles.cellCode}>{cell}</code>
  }
  return <DocInline text={cell} />
}

/** Reference table: tinted header row, monospace chips for parameter / field names. */
export function DocTable({ table, id, 'data-testid': testId = 'doc-table' }: DocTableProps) {
  const codeColumns = new Set(table.codeColumns ?? [0])
  return (
    <div className={styles.tableWrap} id={id} data-testid={testId}>
      <table className={styles.table}>
        <thead>
          <tr>
            {table.columns.map(column => (
              <th key={column} scope="col">
                <DocInline text={column} />
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {table.rows.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((cell, cellIndex) => (
                <td
                  key={cellIndex}
                  className={clsx(cellIndex > 0 && cellIndex < row.length - 1 && styles.cellMuted)}
                >
                  <Cell cell={cell} mono={codeColumns.has(cellIndex)} />
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}
